<template>
    <v-expansion-panels>
        <v-expansion-panel>
            <v-expansion-panel-header>Preview</v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row>
                    <v-col class="col-12">
                        <h2>{{postItem.title}}</h2>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-carousel hide-delimiters touchless height="300">
                            <v-carousel-item
                                    v-for="(item) in postItem.opener_images"
                                    :key="item.name"
                                    :src="item.url"
                            ></v-carousel-item>
                        </v-carousel>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-12 info-box">
                        <a v-show="postItem.attribute_zubereitungszeit" href="#" class="custom-tooltip" title="Zubereitungszeit">
                            <span id="zubereitungszeit">{{postItem.attribute_zubereitungszeit}}</span>
                        </a>
                        <a v-show="postItem.attribute_wartezeit" href="#" class="custom-tooltip" title="Wartezeit">
                            <span id="wartezeit">{{postItem.attribute_wartezeit}}</span>
                        </a>
                        <a v-show="postItem.attribute_backzeit" href="#" class="custom-tooltip" title="Backzeit">
                            <span id="backzeit">{{postItem.attribute_backzeit}}</span>
                        </a>
                        <a v-show="postItem.attribute_grad" href="#" class="custom-tooltip" title="Grad">
                            <span id="grad">{{postItem.attribute_grad}}</span>
                        </a>
                        <a v-show="postItem.attribute_heizart" href="#" class="custom-tooltip" title="Zubereitungszeit">
                            <span id="heizart">{{postItem.attribute_heizart}}</span>
                        </a>
                        <a v-show="postItem.attribute_kuehlzeit" href="#" class="custom-tooltip" title="Zubereitungszeit">
                            <span id="kuehlzeit">{{postItem.attribute_kuehlzeit}}</span>
                        </a>
                    </v-col>
                </v-row>
                <v-row class="menu-headline-row" v-show="postItem.extraTitle">
                    <v-col></v-col>
                    <v-col><h3>{{postItem.recipe_title}}</h3></v-col>
                    <v-col></v-col>
                </v-row>
                <v-row>
                    <!--<div v-for="(item,index) in postItem.recipe_container">
                        <template v-if="item.content_type == 1">
                            <div class="block">
                                <h3>{$recipe.recipe_item}</h3>
                                <ul class="zutaten">
                        </template>

                        <template v-else-if="item.content_type != 1">
                            <li class="quantity">
                            <span class="recipe_full_unit">
                                <span class="recipe_amount">{{item.recipe_amount}}</span>
                                &nbsp;
                                <span class="recipe_unit">{{ingredientValue[item.recipe_unit].text}}</span>
                            </span>
                                <span class="recipe_full_name">{{item.recipe_item}}</span>
                            </li>
                        </template>

                        <template v-if="postItem.recipe_container[index+1].content_type == 1">

                        </template>
                    </div> -->
                </v-row>
                <v-row>
                    <v-col class="col-12" v-html="postItem.opener_text">
                    </v-col>
                </v-row>
                <v-row>
                    <div v-for="(ct,index) in postItem.content_container" :key="'recipe_'+index" class="col-12">
                        <template v-if="ct.content_type == 2">
                            <p v-html="ct.content_element_text"></p>
                        </template>
                        <template v-if="ct.content_type == 3">
                            <h2 class="zubereitung-headline-row" v-if="ct.content_element_title != ''">
                                <span class="post-label">{{ct.content_element_title}}</span>
                            </h2>
                            <p v-if="ct.content_element_text != ''" v-html="ct.content_element_text"></p>
                        </template>
                        <template v-if="ct.content_type == 4">
                            <div class="tipp-box">
                                <h3 v-if="ct.content_element_title != ''">{{ct.content_element_title}}</h3>
                                <p v-if="ct.content_element_text != ''" v-html="ct.content_element_text"></p>
                            </div>
                        </template>
                        <template v-if="ct.content_type == 6 && ct.content_element_text">
                            <div class="yt--wrapper">
                                <div class="h_iframe" data-yt="{$ct.content_element_text}">
                                    <iframe class="no-print" :src="'https://www.youtube.com/embed/'+ct.content_element_text" allowfullscreen="" width="100%" height="419" frameborder="0"></iframe>
                                </div>
                            </div>
                        </template>
                    </div>
                </v-row>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
  export default {
    name: 'PostPreviewComponent',
    props: ['postItem'],
  }
</script>

<style scoped>
    .info-box {
        clear:both;float:left;width:100%;display: flex;justify-content: space-between;
    }
    .zubereitung--angaben {
        width: 80%;
        display: flex;
        justify-content: center;
    }
    .info-box span {
        font-size: 16px;
        display: inline-block;
        padding: 0 0 0 40px;
        height:30px;
        line-height:30px;
    }

    .info-box span{background-position-x:0%;background-position-y:0%;background-repeat:repeat;background-size:auto;background-repeat:no-repeat;background-size:30px;background-position:center left;padding-left:32px;}
    .info-box span#zubereitungszeit {background: url(~@/assets/zubereitungszeit_icon.png) no-repeat;}
    .info-box span#backzeit {background: url(~@/assets/backzeit_icon.png) no-repeat;}
    .info-box span#wartezeit {background: url(~@/assets/wartezeit_icon.png) no-repeat;}
    .info-box span#kuehlzeit {background: url(~@/assets/kuehlzeit_icon.png) no-repeat;}
    .info-box span#grad {background: url(~@/assets/grad_icon.png) no-repeat;}
    .info-box span#heizart {background: url(~@/assets//heizart_icon.png) no-repeat;}

    .menu-headline-row div:nth-child(2n+1){
        width: 25%;
        height: 4em;
        margin-top: 10px;
        margin-bottom: 33px;
        border-bottom: 3px solid #D01774;
        float: left;
    }
    .menu-headline-row div:nth-child(2){
        width: 50%;
        float: left;
        padding-right: 15px;
        padding-left: 15px;
    }

    .menu-headline-row div:nth-child(2) h3{
        text-align: center;
        padding: 10px;
        border-radius: 6px;
        background: #D01774;
        color: #fff;
        font-weight: 600;
    }
    h2.zubereitung-headline-row::before {
        content: "";position:absolute;top:50%;width:100%;height:3px;background: #d01774;z-index:-1;border-radius:1.5px;
    }
    h2.zubereitung-headline-row {
        width: 100%;
        position: relative;
        padding: 0;
        line-height: 46px;
        margin: 1.75rem 0 0.625rem 0;
        z-index: 2;
    }
    h2.zubereitung-headline-row span.post-label::after {
        content:"";position:absolute;width:10px;height:100%;background: #fff;right:-10px;top:0;
    }
    h2.zubereitung-headline-row span.post-label::after before {
        content:"";position:absolute;width:10px;height:100%;background: #fff;left:-10px;top:0;
    }
    h2.zubereitung-headline-row span.post-label {
        background: #d01774;
        font-weight: 600;
        padding: 0 10px;
        color: #fff;
        border-radius: 6px;
        font-size: 1.125rem;
        width: 50%;
        text-align: center;
        display: block;
        margin: 0 auto;
        float: none;
        position: relative;
        box-sizing: border-box;
    }

    span.post-label {
        background: #d01774;
        font-weight: 600;
        padding: 0 10px;
        color: #fff;
        border-radius: 6px;
        font-size: 1.125rem;
        width: 50%;
        text-align: center;
        display: block;
        margin: 0 auto;
        float: none;
        position: relative;
        box-sizing: border-box;
    }

    @media screen and (max-width: 768px){
        span.post-label{
            word-wrap:break-word;
        }
    }

    .tipp-box {
        padding: 20px 25px;
        background: #f4f3f8;
        border-radius: 10px;
        margin: 20px 0;
    }
    .tipp-box h3 {
        margin-top: 10px;
    }
</style>